import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { Etudiant, CreateEtudiantRequest } from '@/shared/types/etudiant'

export const etudiantsApi = {
  getAll: () =>
    api.get<ApiResponse<Etudiant[]>>('/api/etudiants').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<Etudiant>>(`/api/etudiants/${id}`).then((r) => r.data.data),

  getByUserId: (userId: number) =>
    api.get<ApiResponse<Etudiant>>(`/api/etudiants/user/${userId}`).then((r) => r.data.data),

  create: (data: CreateEtudiantRequest) =>
    api.post<ApiResponse<Etudiant>>('/api/etudiants/create', data).then((r) => r.data.data),

  update: (id: number, formData: FormData) =>
    api.put<ApiResponse<Etudiant>>(`/api/etudiants/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/etudiants/${id}`),
}
